import { render, staticRenderFns } from "./EnhancedPricingTab.vue?vue&type=template&id=f3e87f1e&scoped=true&"
import script from "./EnhancedPricingTab.vue?vue&type=script&lang=js&"
export * from "./EnhancedPricingTab.vue?vue&type=script&lang=js&"
import style0 from "./EnhancedPricingTab.vue?vue&type=style&index=0&id=f3e87f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e87f1e",
  null
  
)

export default component.exports